import importVue from "vue";

export { Component, Prop, Watch, Emit, Inject, Provide } from "vue-property-decorator";

export const Vue = importVue;